import * as React from "react"
import { EarSmall } from "./small"
import { EarBig } from "./big"

const _Ear = ({
  color,
  size,
  isEditor
}: {
  color: string
  size: string
  isEditor?: boolean
}) => {
  return (
    <>
      {size === "small" && <EarSmall color={color} isEditor={isEditor} />}
      {size === "big" && <EarBig color={color} isEditor={isEditor} />}
    </>
  )
}

export const Ear = React.memo(_Ear)
